import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const ERROR_CONTAINER_BACKGROUND = "linear-gradient(0deg, #FFE8B0 61.04%, #FFC02B 97.06%)";

export const CardContainer = styled.div<{ $isError?: boolean }>(({ theme, $isError }) => ({
    borderTopLeftRadius: theme.cornerRadius.xLarge,
    borderTopRightRadius: theme.cornerRadius.xLarge,
    background: $isError ? ERROR_CONTAINER_BACKGROUND : "#018029",
}));

export const LottieWrapper = styled.div({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
});

export const InstructionsContainer = styled.div({
    position: "relative",
    display: "flex",
    flexDirection: "column",
});

export const ErrorContainer = styled.div(({ theme }) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "480px",
    gap: theme.spacing.large,
    paddingTop: theme.spacing.large,
    borderTopLeftRadius: theme.cornerRadius.xLarge,
    borderTopRightRadius: theme.cornerRadius.xLarge,
    background: ERROR_CONTAINER_BACKGROUND,
    overflow: "hidden",
    paddingBottom: "53px",
}));

export const ErrorTopContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.medium,
}));

export const WarningIconContainer = styled.div({
    display: "flex",
    justifyContent: "center",
    width: "113px",
});

export const ErrorTextWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.x1,
    padding: "0 48px",
}));

export const ErrorImageWrapper = styled.div({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
});

export const BodyText = styled(Text)({
    maxWidth: "200px",
});
